import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheCinematicVision from "./sections/TheCinematicVision";
import JoinTheMovement from "./sections/JoinTheMovement";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheCinematicVision />
      <JoinTheMovement />
      <Footer />
    </div>;
}